export default {
  install: (Vue) => {
    Vue.prototype.$sklonyator = function (num, words) {
      const cases = [2, 0, 1, 1, 1, 2];
      if (num % 100 > 4 && num % 100 < 20) return words[2];
      return words[cases[num % 10 < 5 ? num % 10 : 5]];
    };
  },
};
